import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { getMarket } from './utils/marketDetector';
import { getMarketContent } from './data/marketContent';
import { injectCSSVars } from './utils/brandStyles';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import FreeAssessment from './pages/FreeAssessment';
import AIConsulting from './pages/AIConsulting';
import CloudMigration from './pages/CloudMigration';
import Cybersecurity from './pages/Cybersecurity';
import ITConsulting from './pages/ITConsulting';
import ManagedIT from './pages/ManagedIT';
import SmallBusinessSolution from './pages/SmallBusinessSolution';
import Insights from './pages/Insights';
import ArticleDetail from './pages/ArticleDetail';
import MWOPreview from './pages/MWOPreview';

function App() {
  const [market, setMarket] = useState('bg');
  const [content, setContent] = useState(getMarketContent('bg'));

  useEffect(() => {
    const detectedMarket = getMarket();
    setMarket(detectedMarket);
    setContent(getMarketContent(detectedMarket));
    injectCSSVars(detectedMarket);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className={market === 'mwo' ? 'brand-mwo' : 'brand-mindit'} style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Header market={market} content={content} />

        <main style={{ flex: 1 }}>
          <Routes>
            {/* Homepage */}
            <Route path="/" element={<Home market={market} content={content} />} />

            {/* About & Contact */}
            <Route path="/about" element={<About market={market} content={content} />} />
            <Route path="/contact" element={<Contact market={market} content={content} />} />

            {/* Redirect old solution paths to services */}
            <Route path="/solutions/micro-business" element={<Navigate to="/services/small-business" replace />} />
            <Route path="/solutions/small-business" element={<Navigate to="/services/small-business" replace />} />
            <Route path="/solutions/enterprise" element={<Navigate to="/" replace />} />

            {/* Service Pages */}
            <Route path="/services/small-business" element={<SmallBusinessSolution market={market} />} />
            <Route path="/services/assessment" element={<FreeAssessment market={market} />} />
            <Route path="/services/ai-consulting" element={<AIConsulting market={market} />} />
            <Route path="/services/cloud" element={<CloudMigration market={market} />} />
            <Route path="/services/managed-it" element={<ManagedIT market={market} />} />
            <Route path="/services/security" element={<Cybersecurity market={market} />} />
            <Route path="/services/consulting" element={<ITConsulting market={market} />} />

            {/* Insights / Blog */}
            <Route path="/insights" element={<Insights market={market} />} />
            <Route path="/insights/:slug" element={<ArticleDetail market={market} content={content} />} />

            {/* Preview (unlisted in nav) — boutique MWO rework */}
            <Route path="/preview/mwo" element={<MWOPreview />} />

            {/* Fallback - redirect unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <Footer market={market} content={content} />
      </div>
    </Router>
  );
}

export default App;
